var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgWooBanner = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 266,
  height: 81,
  fill: "none",
  viewBox: "0 0 266 81",
  ref: ref
}, props), /*#__PURE__*/React.createElement("g", {
  filter: "url(#svg-3012367978__a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#svg-3012367978__b)"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-3012367978__c)",
  d: "M238.7 23.3h-26.1a2.9 2.9 0 0 0-2.9 2.9v26.1c0 6.407 5.194 11.6 11.6 11.6h30.224a1.45 1.45 0 0 0 1.435-1.659l-5.302-36.458a2.9 2.9 0 0 0-2.869-2.483z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-3012367978__d)",
  d: "M212.119 20.4c.308 0 .603.122.821.34l27.811 27.81c.543.544.849 1.282.849 2.051V55.2a5.8 5.8 0 0 1-5.8 5.8h-17.378a8.7 8.7 0 0 1-8.7-8.722l.076-29.562a2.32 2.32 0 0 1 2.321-2.316"
})), /*#__PURE__*/React.createElement("mask", {
  id: "svg-3012367978__f",
  width: 44,
  height: 41,
  x: 209,
  y: 23,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-3012367978__e)",
  d: "M247.756 25.79a2.9 2.9 0 0 0-2.871-2.49H209.7v29c0 6.407 5.194 11.6 11.6 11.6h30.228a1.45 1.45 0 0 0 1.436-1.655z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#svg-3012367978__f)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#svg-3012367978__g)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 240.7,
  height: 43.5,
  x: 0.9,
  y: 8.8,
  fill: "url(#svg-3012367978__h)",
  rx: 17.4,
  shapeRendering: "crispEdges"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-3012367978__i)",
  d: "M.9 26.2c0-9.61 7.79-17.4 17.4-17.4h205.9c9.61 0 17.4 7.79 17.4 17.4v29a9.9 9.9 0 0 0-7.001-2.9H7.901A9.9 9.9 0 0 0 .9 55.2z"
})))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#svg-3012367978__j)"
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-3012367978__k)",
  d: "M27.3 23.3h26.1a2.9 2.9 0 0 1 2.9 2.9v26.1c0 6.407-5.193 11.6-11.6 11.6H14.476a1.45 1.45 0 0 1-1.435-1.658l5.302-36.459a2.9 2.9 0 0 1 2.87-2.483z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-3012367978__l)",
  d: "M53.88 20.4a1.16 1.16 0 0 0-.82.34L25.25 48.55a2.9 2.9 0 0 0-.85 2.051v4.6a5.8 5.8 0 0 0 5.8 5.8h17.378a8.7 8.7 0 0 0 8.7-8.723l-.076-29.562a2.32 2.32 0 0 0-2.321-2.316"
})), /*#__PURE__*/React.createElement("mask", {
  id: "svg-3012367978__n",
  width: 44,
  height: 41,
  x: 13,
  y: 23,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-3012367978__m)",
  d: "M18.244 25.79a2.9 2.9 0 0 1 2.871-2.49H53.4a2.9 2.9 0 0 1 2.9 2.9v26.1c0 6.407-5.193 11.6-11.6 11.6H16.144a2.9 2.9 0 0 1-2.871-3.31z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#svg-3012367978__n)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#svg-3012367978__o)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 240.7,
  height: 43.5,
  x: 24.4,
  y: 8.8,
  fill: "url(#svg-3012367978__p)",
  rx: 17.4,
  shapeRendering: "crispEdges"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-3012367978__q)",
  d: "M24.4 26.2c0-9.61 7.79-17.4 17.4-17.4h205.9c9.61 0 17.4 7.79 17.4 17.4v29a9.9 9.9 0 0 0-7.001-2.9H31.401a9.9 9.9 0 0 0-7.001 2.9z"
})))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-3012367978__r)",
  d: "M24.4 52.3h217.2V26.2c0-9.61-7.79-17.4-17.4-17.4H41.8c-9.61 0-17.4 7.79-17.4 17.4z"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#svg-3012367978__s)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m37.146 40.198 1.035-5.847c1.583.579 3.745 1.218 5.268 1.218 1.4 0 2.284-.365 2.284-1.187 0-.914-1.462-1.31-3.137-1.919-2.588-.944-5.054-2.497-5.054-6.15 0-4.538 3.989-6.913 8.587-6.913 2.161 0 4.323.427 6.029 1.005l-.792 5.572c-1.675-.487-3.563-.822-4.78-.822-1.066 0-1.95.366-1.95 1.066 0 .761 1.31 1.127 2.832 1.705 2.893 1.097 5.299 2.436 5.329 6.425.03 4.72-3.471 7.187-8.587 7.187-2.436 0-5.085-.58-7.064-1.34m24.165 6.516-6.425.152.182-14.19-.121-7.52 6.09-.427.213 1.918c.609-1.248 2.1-2.161 4.11-2.161 4.294 0 7.43 3.288 7.43 8.586 0 5.299-3.35 8.313-7.886 8.313-1.644 0-2.832-.578-3.624-1.614zm2.436-10.992c1.614 0 2.497-1.127 2.527-2.741.03-1.827-1.066-2.954-2.497-2.954s-2.497 1.036-2.527 2.802.913 2.892 2.497 2.892m24.736-.549.944 4.903c-1.34.64-3.563 1.4-6.273 1.4-5.116 0-9.227-3.044-9.227-8.525 0-5.116 3.715-8.526 8.587-8.526 5.299 0 7.643 3.532 7.643 7.216 0 .883-.091 1.736-.335 2.528l-9.196.152c.183 1.279 1.553 1.796 2.893 1.796 1.37 0 3.289-.456 4.963-.944m-5.938-5.937c-1.249 0-1.98.974-1.98 1.918l3.685-.091c.03-1.096-.609-1.827-1.705-1.827m15.567 3.684c0 1.858 1.37 2.862 3.136 2.862.944 0 2.284-.304 3.441-.73l.792 5.39c-1.218.608-3.015 1.065-4.994 1.065-4.841 0-9.043-2.954-9.043-8.343 0-5.755 4.171-8.74 9.317-8.74 1.462 0 3.106.275 4.415.762l-.791 5.359c-1.066-.335-2.101-.609-3.045-.609-1.736 0-3.228 1.035-3.228 2.984m9.077-12.758c0-2.071 1.614-3.533 3.654-3.533 2.253 0 3.898 1.28 3.898 3.41 0 2.04-1.645 3.502-3.837 3.502-2.101 0-3.715-1.34-3.715-3.38m.274 4.993c2.741.03 5.329-.213 6.912-.396l-.091 16.139-6.669.213zm24.879 6.243.214 5.572c.06 1.462.517 2.558.883 3.593l-5.938.792a7 7 0 0 1-.761-1.736c-.823 1.096-2.193 1.827-4.142 1.827-3.288 0-5.846-1.796-5.846-5.176 0-3.959 3.471-5.116 6.729-5.116.914 0 1.614.122 2.467.579-.061-1.584-1.066-2.254-2.527-2.254-1.371 0-3.502.548-4.842 1.005L118 25.612c1.371-.487 3.989-1.157 6.456-1.157 4.293 0 7.734 2.101 7.886 6.943m-6.211 5.054v-1.644a4.2 4.2 0 0 0-1.34-.244c-.914 0-1.766.275-1.766 1.127 0 .822.761 1.218 1.522 1.218.701 0 1.218-.213 1.584-.457m9.074-18.178 6.699-.396-.061 23.08-6.516.092zm27.325 1.035c6.638 0 10.932 4.354 10.932 10.688 0 6.577-4.355 11.419-10.962 11.419-6.821 0-10.871-4.629-10.871-11.023 0-6.547 4.781-11.084 10.901-11.084m.122 15.651c2.406 0 3.745-2.253 3.745-4.963 0-2.619-1.461-4.628-3.775-4.628s-3.807 1.918-3.807 4.78c0 2.467 1.218 4.811 3.837 4.811m32.181-9.896 3.562-.091-.091 5.146h-3.441l.152 10.749-6.546.213-.031-11.084-4.841.06.152 10.81-6.547.214-.03-11.084-2.649.06v-4.871l2.74-.091v-.823c0-4.324 2.923-6.425 7.034-6.425 1.949 0 2.801.396 2.801.396l-.335 4.964s-.609-.214-1.309-.214c-1.37 0-1.888.853-1.888 2.102l4.964-.031v-.792c0-4.445 2.831-6.577 6.912-6.577 1.948 0 3.38.396 3.38.396l-.274 4.902s-1.127-.152-1.827-.152c-1.523 0-1.888.975-1.888 2.223m19.018 10.11.944 4.902c-1.34.64-3.563 1.4-6.273 1.4-5.115 0-9.226-3.044-9.226-8.525 0-5.116 3.715-8.526 8.587-8.526 5.298 0 7.643 3.532 7.643 7.216 0 .883-.092 1.736-.335 2.528l-9.196.152c.182 1.279 1.553 1.796 2.893 1.796 1.37 0 3.288-.456 4.963-.944m-5.938-5.938c-1.248 0-1.979.974-1.979 1.918l3.684-.091c.031-1.096-.609-1.827-1.705-1.827m9.721-4.202 5.725-.305.365 2.436c1.005-2.04 2.558-2.71 4.415-2.71.609 0 1.249.152 1.249.152l-.335 6.09c-.396-.06-.914-.152-1.553-.152-1.827 0-3.289 1.188-3.289 3.563l.153 6.82-6.456.153z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "svg-3012367978__c",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(34.238 38.11 375.34)scale(57.1281 118.202)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF4C4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.484,
  stopColor: "#E81A8E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#FF4694"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "svg-3012367978__d",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(145.763 110.493 56.311)scale(57.1282 118.202)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F91DA6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.458,
  stopColor: "#FC2C8D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#FE3B72"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "svg-3012367978__e",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(34.238 43.91 394.17)scale(57.1281 118.202)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#006A97"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#1497CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#12A9CA"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "svg-3012367978__k",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-47.2288 32.14126 -66.5025 -97.71965 48.221 43.6)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF4C4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.484,
  stopColor: "#E81A8E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#FF4694"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "svg-3012367978__l",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(47.2286 32.14173 -66.50335 97.71907 32.479 40.7)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F91DA6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.458,
  stopColor: "#FC2C8D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#FE3B72"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "svg-3012367978__m",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-47.2288 32.14126 -66.5025 -97.71965 36.621 43.6)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#006A97"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#1497CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#12A9CA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-3012367978__h",
  x1: 228.061,
  x2: 226.596,
  y1: -36.059,
  y2: 55.71,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1FA7F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.481,
  stopColor: "#329BF0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#34C5F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-3012367978__i",
  x1: 0.9,
  x2: 13.339,
  y1: 8.8,
  y2: 90.118,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF465D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F711BA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-3012367978__p",
  x1: 251.561,
  x2: 250.096,
  y1: -36.059,
  y2: 55.71,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1FA7F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.481,
  stopColor: "#329BF0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#34C5F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-3012367978__q",
  x1: 24.4,
  x2: 36.839,
  y1: 8.8,
  y2: 90.118,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF465D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F711BA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-3012367978__r",
  x1: 24.4,
  x2: 36.494,
  y1: 52.3,
  y2: -23.797,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF465D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F711BA"
})), /*#__PURE__*/React.createElement("filter", {
  id: "svg-3012367978__a",
  width: 265.2,
  height: 85.7,
  x: 0.4,
  y: -5.4,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 11.6,
  result: "effect1_dropShadow_17531_16502"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 12
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.48 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_17531_16502"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_17531_16502",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "svg-3012367978__g",
  width: 269.7,
  height: 72.5,
  x: -13.6,
  y: -5.7,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 11.6,
  result: "effect1_dropShadow_17531_16502"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 13.05
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.883333 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_17531_16502"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.8
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_17531_16502",
  result: "effect2_dropShadow_17531_16502"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_17531_16502",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "svg-3012367978__o",
  width: 269.7,
  height: 72.5,
  x: 9.9,
  y: -5.7,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 11.6,
  result: "effect1_dropShadow_17531_16502"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 13.05
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.883333 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_17531_16502"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.8
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_17531_16502",
  result: "effect2_dropShadow_17531_16502"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_17531_16502",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "svg-3012367978__s",
  width: 197.3,
  height: 35.294,
  x: 34.617,
  y: 16.261,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.16
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.264
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.6 0 0 0 0 0.0509804 0 0 0 0 0.290196 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_17531_16502"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_17531_16502",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "svg-3012367978__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M209.7 8.8h43.5v55.1h-43.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "svg-3012367978__j"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.8 8.8h43.5v55.1H12.8z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWooBanner);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };